import { gql } from '@apollo/client';

export const GET_HISTORICAL_OVERRIDE_ACTIVE_IMPORTS = gql`
    query GetHistoricalOverrideActiveImports($input: GetImportLogsInput!) {
        getManualImportLogs(input: $input) {
            total
            logs {
                id
                fileName
                status
                startedAt
                recordsProcessed
                metadata
                createdBy {
                    id
                    firstName
                    lastName
                }
            }
        }
    }
`;
